import { Injectable } from '@angular/core';
import { configURI } from '../../../shared/apiUrlConfig';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AgentlocationService {
  url = environment.configURI;
  loginId;
  constructor(private http: Http, private httpClient: HttpClient, private userFriendlyMsgs: UserFriendlyMsgs) {
  }

  getAgentLocationDetails(id, flagSelected) {
    let role = parseInt(localStorage.getItem("RoleVal"))
    if (role === 8) {
      return this.httpClient.get(this.url + '/client/vendor/' + id + '/locations').catch(this.userFriendlyMsgs.errorHandler);
    } else {
      if (flagSelected == 'Active Locations') {
        let flag = 'Y';
        return this.httpClient.get(this.url + '/vendor/' + id + '/locations?locationStatus=' + flag).catch(this.userFriendlyMsgs.errorHandler);
      }
      else if (flagSelected == 'Inactive Locations') {
        let flag = 'N';
        return this.httpClient.get(this.url + '/vendor/' + id + '/locations?locationStatus=' + flag).catch(this.userFriendlyMsgs.errorHandler);
      }
      else {
        let flag = 1;
        return this.httpClient.get(this.url + '/vendor/' + id + '/locations?isDeleted=' + flag).catch(this.userFriendlyMsgs.errorHandler);
      }
    }
  }

  locationDetailsOfAgent(locationId) {
    let vendor_id = localStorage.getItem('AgentId');
    let role = parseInt(localStorage.getItem("RoleVal"))
    if (role === 8) {
      return this.httpClient.get(this.url + '/client/location/' + locationId + '/' + vendor_id).catch(this.userFriendlyMsgs.errorHandler);
    } else {
      return this.httpClient.get(this.url + '/location/' + locationId + '/' + vendor_id).catch(this.userFriendlyMsgs.errorHandler);
    }

  }

  locationDetsOfAgent(locationId, vendorId) {
    return this.httpClient.get(this.url + '/location/' + locationId + '/' + vendorId).catch(this.userFriendlyMsgs.errorHandler);    
  }

  getRemediationDetails(vendorId){
    return this.httpClient.get(this.url + '/remediation/locations/'+ vendorId).catch(this.userFriendlyMsgs.errorHandler);  
  }

  saveAdditionalLocationData(data) {
    let vendor_id = localStorage.getItem('AgentId');
    this.loginId = localStorage.getItem('loginID');
    const body = {
      _id: data._id,
      locationid: data.LocationId,
      hoursofoperation: data.HoursOfOperation,
      redemptionhours: data.RedemptionHours,
      transporthours: data.TransportationHours,
      afterhoursphone: data.AfterHoursPhone,
      securitycamera: data.SecurityCamera == true ? true : false,
      created_by: this.loginId,
      updated_by: this.loginId
    }
    return this.httpClient.put(this.url + '/location/' + data.LocationId + "/" + vendor_id, body).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/agent_location/agentlocation.service.ts